export default __webpack_public_path__ + "static/media/03.95d59758.jpg";